export default {
    title: '20.000 Leguas de Viaje Submarino',
    cover: '/dev-content-files/audiobook_cover.jpeg',
    tags: {
        keyword: ['Ficcion', 'Secundaria', 'Convivencia', 'Novela', 'Lengua'],
        author: ['Julio Verne'],
        category: ['Ficcion'],
        collection: ['Clasicos'],
    },
    duration: '19:36:37',
    chapters: '42',
    issue_url: 'volpe.localhost',
    publication_date: '1869',
    twitterUser: 'publicala',
    lang: 'es',
    aboutThisPublication:
        'Veinte mil leguas de viaje submarino es una obra narrada en primera persona por el profesor francés Pierre Aronnax, notable biólogo que es hecho prisionero por el Capitán Nemo y es conducido por los océanos a bordo del submarino Nautilus, en compañía de su criado Conseil y el arponero canadiense Ned Land.',
};
